import React from 'react';
import { BRAND } from '../lib/brand';
import stockVestedIconLight from '../assets/brand/stockvested-icon-light.png';
import stockVestedIconDark from '../assets/brand/stockvested-icon-dark.png';

function AppBrand({ theme = 'dark', compact = false }) {
  const isDarkMode = theme === 'dark';
  const brandIcon = isDarkMode ? stockVestedIconDark : stockVestedIconLight;

  return (
    <div className={`app-brand ${compact ? 'app-brand-compact' : ''}`}>
      <img
        src={brandIcon}
        alt={`${BRAND.name} logo`}
        className="app-brand-icon"
      />
      <div className="app-brand-copy">
        <div className="app-brand-name">{BRAND.name}</div>
      </div>
    </div>
  );
}

export default AppBrand;